import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useAgency'
import { useRelations } from '@hooks/useAgencyPublication'

interface AgencyPublicationListItemProps {
  agencyPublication:{},
}

const AgencyPublicationListItem = (props: AgencyPublicationListItemProps) => {
  const { agencyPublication } = props

  const {
    agency: {
      // @ts-expect-error TS2339
      id,
      // @ts-expect-error TS2339
      title,
    },
  } = useRelations(agencyPublication)

  const { editAgencyRelationsUrl } = generateUrls({ id })

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyPublicationListItem
